/* IMPORTANT: This file is auto-generated. Do not modify it directly or changes will be lost. */
if("#cart"==window.location.hash){document.querySelector("cart-drawer").setAttribute("open","")}